import React, { useState } from "react";
import { Radio, Drawer } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import CuttingIcon from "../../assets/img/svg/xmanifestrecycleicon.svg";
import ShipmentIcon from "../../assets/img/svg/xshipmentIcon.svg";
import CODIcon from "../../assets/img/svg/xcod.svg";
import RecycleManifest from "./recycle-manifest";
// import RecycleCod from "./recycle-cod";
import ShipmentProcess from "../recycleShipment/shipmentProcess";
import ShipmentHistory from "../recycleShipment/shipmentHistory";
import shipmentInbox from "../../assets/img/svg/xshipment-manifest.svg";
import CodLifeCycle from "../recycleShipment/codLifeCycle";

const ManifestRecycle = () => {
  const [data, setBatchData] = useState([])
  const [text, setText] = useState([]);
  const [clearedData, setClearedData] = useState([]);

  const [visible, setVisible] = useState(false);
  const [processingMode, setProcessingMode] = useState("single");

  const handleModeChange = (e) => {
      setProcessingMode(e.target.value);
      setBatchData([]);
  };
  return (
     <>
        <Drawer
            title={<div className="slider-title-with-icon " style={{ display: "flex", flexDirection: "row", columnGap: "15px", alignItems: "center" }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z" stroke="#0009E2" stroke-width="1.5" />
                    <path opacity="0.5" d="M4 14.25C3.58579 14.25 3.25 14.5858 3.25 15C3.25 15.4142 3.58579 15.75 4 15.75V15V14.25ZM20 15.75C20.4142 15.75 20.75 15.4142 20.75 15C20.75 14.5858 20.4142 14.25 20 14.25V15V15.75ZM14.5987 16.4013L14.0684 15.8709H14.0684L14.5987 16.4013ZM14.8284 16.1716L14.2981 15.6412V15.6412L14.8284 16.1716ZM9.15 16.25L8.59805 16.7578H8.59805L9.15 16.25ZM9.18546 16.2885L9.73741 15.7807H9.73741L9.18546 16.2885ZM10.2809 17.2877L9.94463 17.9581H9.94463L10.2809 17.2877ZM10.4692 17.3703L10.7348 16.6689H10.7348L10.4692 17.3703ZM13.5262 17.3082L13.2057 16.6301H13.2057L13.5262 17.3082ZM13.3458 17.3829L13.5987 18.089L13.5987 18.089L13.3458 17.3829ZM16.0631 15.1522L15.776 14.4593H15.776L16.0631 15.1522ZM7.87676 15.1477L8.15966 14.4531L8.15966 14.4531L7.87676 15.1477ZM7.97471 15.1907L7.65508 15.8692L7.65508 15.8692L7.97471 15.1907ZM4.25 15C4.25 15.4142 4.58579 15.75 5 15.75C5.41421 15.75 5.75 15.4142 5.75 15H5H4.25ZM18.25 15C18.25 15.4142 18.5858 15.75 19 15.75C19.4142 15.75 19.75 15.4142 19.75 15H19H18.25ZM4 15V15.75H6.30147V15V14.25H4V15ZM17.6569 15V15.75H20V15V14.25H17.6569V15ZM14.5987 16.4013L15.1291 16.9316L15.3588 16.7019L14.8284 16.1716L14.2981 15.6412L14.0684 15.8709L14.5987 16.4013ZM9.15 16.25L8.59805 16.7578L8.63351 16.7963L9.18546 16.2885L9.73741 15.7807L9.70195 15.7422L9.15 16.25ZM9.18546 16.2885L8.63351 16.7963C9.10743 17.3115 9.46605 17.718 9.94463 17.9581L10.2809 17.2877L10.6172 16.6173C10.4413 16.5291 10.2877 16.3789 9.73741 15.7807L9.18546 16.2885ZM11.9462 17.5V16.75C11.1333 16.75 10.9189 16.7387 10.7348 16.6689L10.4692 17.3703L10.2035 18.0717C10.7042 18.2613 11.2462 18.25 11.9462 18.25V17.5ZM10.2809 17.2877L9.94463 17.9581C10.0289 18.0004 10.1153 18.0383 10.2035 18.0717L10.4692 17.3703L10.7348 16.6689C10.6948 16.6538 10.6555 16.6365 10.6172 16.6173L10.2809 17.2877ZM14.5987 16.4013L14.0684 15.8709C13.5252 16.4141 13.3746 16.5503 13.2057 16.6301L13.5262 17.3082L13.8467 17.9863C14.3058 17.7693 14.6609 17.3998 15.1291 16.9316L14.5987 16.4013ZM11.9462 17.5V18.25C12.6083 18.25 13.1206 18.2602 13.5987 18.089L13.3458 17.3829L13.093 16.6768C12.9171 16.7398 12.7143 16.75 11.9462 16.75V17.5ZM13.5262 17.3082L13.2057 16.6301C13.1689 16.6475 13.1313 16.6631 13.093 16.6768L13.3458 17.3829L13.5987 18.089C13.683 18.0588 13.7658 18.0245 13.8467 17.9863L13.5262 17.3082ZM17.6569 15V14.25C16.9005 14.25 16.3135 14.2367 15.776 14.4593L16.0631 15.1522L16.3501 15.8451C16.5477 15.7633 16.7782 15.75 17.6569 15.75V15ZM14.8284 16.1716L15.3588 16.7019C15.9801 16.0806 16.1524 15.927 16.3501 15.8451L16.0631 15.1522L15.776 14.4593C15.2386 14.6819 14.8329 15.1065 14.2981 15.6412L14.8284 16.1716ZM6.30147 15V15.75C7.17044 15.75 7.39887 15.7629 7.59386 15.8423L7.87676 15.1477L8.15966 14.4531C7.62918 14.2371 7.04924 14.25 6.30147 14.25V15ZM9.15 16.25L9.70195 15.7422C9.19566 15.1919 8.81252 14.7564 8.29435 14.5122L7.97471 15.1907L7.65508 15.8692C7.84554 15.9589 8.00971 16.1183 8.59805 16.7578L9.15 16.25ZM7.87676 15.1477L7.59386 15.8423C7.6145 15.8507 7.63491 15.8597 7.65508 15.8692L7.97471 15.1907L8.29435 14.5122C8.24999 14.4913 8.20508 14.4716 8.15966 14.4531L7.87676 15.1477ZM6.5 12V12.75H17.5V12V11.25H6.5V12ZM17.5 12V12.75C17.9142 12.75 18.25 13.0858 18.25 13.5H19H19.75C19.75 12.2574 18.7426 11.25 17.5 11.25V12ZM5 13.5H5.75C5.75 13.0858 6.08579 12.75 6.5 12.75V12V11.25C5.25736 11.25 4.25 12.2574 4.25 13.5H5ZM6.5 9V9.75H17.5V9V8.25H6.5V9ZM17.5 9V9.75C17.9142 9.75 18.25 10.0858 18.25 10.5H19H19.75C19.75 9.25736 18.7426 8.25 17.5 8.25V9ZM5 10.5H5.75C5.75 10.0858 6.08579 9.75 6.5 9.75V9V8.25C5.25736 8.25 4.25 9.25736 4.25 10.5H5ZM5 10.5H5.75V7.5H5H4.25V10.5H5ZM6.5 6V6.75H17.5V6V5.25H6.5V6ZM19 7.5H18.25V10.5H19H19.75V7.5H19ZM17.5 6V6.75C17.9142 6.75 18.25 7.08579 18.25 7.5H19H19.75C19.75 6.25736 18.7426 5.25 17.5 5.25V6ZM5 7.5H5.75C5.75 7.08579 6.08579 6.75 6.5 6.75V6V5.25C5.25736 5.25 4.25 6.25736 4.25 7.5H5ZM5 15H5.75V13.5H5H4.25V15H5ZM19 13.5H18.25V15H19H19.75V13.5H19ZM5 13.5H5.75V10.5H5H4.25V13.5H5ZM19 10.5H18.25V13.5H19H19.75V10.5H19Z" fill="#009DDB" />
                  </svg> {processingMode === "cod" ? "COD Archive" : "Shipment Archive"}
            </div>}
              onClose={() => {
                  setVisible(false)
                  setClearedData([]);
              }}
            open={visible}
            width={'85%'}
            className="story-slider"
            closeIcon={<CloseCircleOutlined />}
            extra={""}
        >
              <ShipmentHistory data={[]} component={processingMode === "cod" ? "COD" : "Shipment Archive"} />
        </Drawer>
      <main className="book-page-main-container">
        <div className="book-page-container">
          <div className="book-page-title-container no-padding-right">
            <div className="book-page-title">
              
                {processingMode === "single" ? (
                    <span>
                    <img src={CuttingIcon} alt="Cutting Icon"></img>
                    </span>
                ): processingMode === "shipment" ? (
                    <span>
                    <img src={ShipmentIcon} alt="Shipment Icon"></img>
                    </span>
                ): (
                    <span>
                    <img src={CODIcon} alt="COD Icon"></img>
                    </span>
                )}
              
                {processingMode === "single" ? (<h2>Recycle Manifest</h2>) : 
                    processingMode === "cod" ? (<h2>Certificate Of Destruction</h2>) : (<h2>Shipment</h2>)}
            </div>
            <div className="book-page-title-container-2">
               {processingMode !== "single" && (
                 <button
                    title={processingMode === "cod" ? "COD Archive" :"Shipment Archive"}
                    className="book-page-title-icon"
                    data-track={processingMode === "cod" ? "open-cod-archive-slider" :"open-shipment-archive-slider"}
                    onClick={() => setVisible(true)}>

                    <img src={shipmentInbox} alt="Cutting Icon"></img>
                 </button>
               )}
              <div className="book-page-title-radio-group">
                <p>Processing Mode:</p>
                <Radio.Group onChange={handleModeChange} value={processingMode}>
                  <Radio value="single" data-track="recycle-manifest-mode">Recycle Manifest</Radio>
                  <Radio value="shipment" data-track="shipment-mode">Shipment </Radio>
                  <Radio value="cod" data-track="cod-mode">COD </Radio>
                </Radio.Group>
              </div>
            </div>
          </div>
          {processingMode === "single" ? (
            <RecycleManifest
              title="Recycle Manifest"
              onDataChange={setBatchData}
              onBatch={setText}
            />
          ) : processingMode === "shipment" ? (
             <ShipmentProcess
                 title="Shipment"
                 onDataChange={data}
             />
          ):(
             <CodLifeCycle
                 title="COD"
                 onDataChange={data}
             />
          )}
        </div>
      </main>
    </>
  );
};
export default ManifestRecycle;
